import React, { useState, useEffect } from 'react';
import { getElementStyleMathValue } from '@gp/utils/common';

export default function useTbodyWidth(table: React.RefObject<HTMLDivElement>) {
  const [tbodyWidth, setTbodyWidth] = useState(0);

  const updateTbodyWidth = () => {
    const tbody = table.current?.querySelector('.tea-table__body') as Element;
    const tbodyWidth = getElementStyleMathValue(tbody, 'width');
    setTbodyWidth(tbodyWidth);
  };

  useEffect(() => {
    updateTbodyWidth();

    window.addEventListener('resize', updateTbodyWidth, false);

    return () => {
      window.removeEventListener('resize', updateTbodyWidth, false);
    };
  }, []);

  return tbodyWidth;
}
